<template>
  <div :class="$style.container" id="uploadDome" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <!--:libraryId="libraryId"-->
    <div :class="$style.top">
      <div>
        <el-row style="height: 32px;">
          <el-col :span="20">
            <div align="left" style="padding-top: 8px; color: cornflowerblue">
              <span style="color: cornflowerblue; font-size: 14px">资料总数：{{ tableData.length }}个（视频：{{ statistics.mp4Num
                ? statistics.mp4Num : 0 }}个，文档： {{ statistics.docNum ? statistics.docNum : 0 }}个，图片：{{
                statistics.imgNum ? statistics.imgNum : 0
                }}个，其他：{{ statistics.restsNum ? statistics.restsNum : 0 }}个）</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div align="right">
              <!--<el-button  @click.stop="uploadEditFile(0,null)" size="small" icon="el-icon-upload" type="primary">上传文件</el-button>-->
              <el-button icon="el-icon-plus" type="success" size="small" @click="addData"
                v-if="$route.query.index != '1'">
                添加资料
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 20px">
        <el-table :data="tableData" border :stripe="true" header-cell-class-name="headerStyle" style="width: 100%">
          <el-table-column fixed prop="title" label="资料名称" sortable min-width="200"> </el-table-column>
          <el-table-column prop="category" label="资料类型" width="110" sortable>
            <template slot-scope="scope">
              {{ isFileType(scope.row.category) }}
            </template>
          </el-table-column>
          <el-table-column prop="size" label="文件大小" width="110" sortable>
            <template slot-scope="scope">
              <span>{{ getFileSize(scope.row.size) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80" sortable>
            <template slot-scope="scope">
              {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="230">
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.$index, scope.row)" type="primary" size="mini">编辑 </el-button>
              <el-button @click="setStatus(scope.row)" :type="scope.row.status == 'ACTIVE' ? 'danger' : 'success'"
                size="mini">
                {{ scope.row.status == "ACTIVE" ? "停用" : "启用" }}
              </el-button>
              <!--<el-button @click="setStatus(scope.row)" v-show="scope.row.status === 'INACTIVE'" type="success" size="mini">启用</el-button>-->
              <el-button @click="downloadFile(scope.row)" type="warning" size="mini"
                :disabled="scope.row.files.length == 0">下载 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--<Pagination :page="page" @changePage="changePageClick"></Pagination>-->
      </div>

      <el-dialog :open="openDialog" :visible.sync="dialogVisible2" width="60%" :show-close="false">
        <div style="margin-top: -40px;">
          <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
            <el-col :span="9">
              <div style="color: #3998F7;padding-top: 8px;font-size: 22px">添加资料</div>
            </el-col>
            <el-col :span="15">
              <div v-if="tab === '图文'" style="width: 345px;display: inline-block">
                <div>
                  <span style="color: #FF9901">最后发布日期 </span><span style="color:#87909A">2019-10-18</span>
                  <el-button size="mini" type="warning">正式发布</el-button>
                  <el-button size="mini" type="success">效果预览</el-button>
                </div>
              </div>
              <div v-if="tab === 'HTML5'" style="width: 345px;display: inline-block">
                <div>
                  <span style="color: #FF9901">最后发布日期 </span><span style="color:#87909A">2019-10-18</span>
                  <el-button size="mini" type="warning">正式发布</el-button>
                  <el-button size="mini" type="success">效果预览</el-button>
                </div>
              </div>
              <div align="right" style="width: 28%;float: right;display: inline-block">
                <el-button type="primary" size="small" :disabled="!canUpload" @click="submitForm">
                  保存
                </el-button>
                <el-button type="danger" size="small" @click="quxiao">
                  取消
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div class="subjectList" style="margin-top: 20px;">
            <el-form ref="form" label-width="100px" class="myElForm demo-ruleForm" :model="onModelType()" :rules="rules"
              hide-required-asterisk>
              <el-form-item label="类型">
                <el-radio-group :disabled="!canUpload" v-model="type" @change="handleTypeChange">
                  <el-radio label="视频"></el-radio>
                  <!-- <el-radio label="音频"></el-radio> -->
                  <el-radio label="幻灯片"></el-radio>
                  <el-radio label="文档"></el-radio>
                  <el-radio label="图库"></el-radio>
                  <!--                                    <el-radio label="图文"  ></el-radio>-->
                  <!--                                    <el-radio label="HTML5"></el-radio>-->
                </el-radio-group>
              </el-form-item>

              <div v-if="tab === '视频'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="video.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="video.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="video" class="a_upload_file upload_star" prop="id">
                  <el-upload v-model="video.id" accept=".mp4" :action="getUrl('VIDEO')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleVideoSuccess"
                    :before-upload="beforeVideoUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                      您可以上传mp4格式的视频文件,文件大小不能超过100M!</div>
                    <span
                      style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                      slot="tip" class="el-upload__tip1">
                      请待进度条走到100%并出现
                    </span>
                    <span>
                      <i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                    </span>
                    <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                      class="el-upload__tip">
                      之后保存，方为上传成功
                    </span>
                  </el-upload>
                </el-form-item>
                <el-row style="margin-top: 30px">
                  <el-col :span="8">
                    <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                      <el-input v-model="video.min" @input="imposeM(video.min, 'video')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">分钟</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                      <el-input v-model="video.miao" @input="impose(video.miao, 'video')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">秒</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="tab === '音频'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="audio.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="audio.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="audio" class="a_upload_file upload_star" prop="id">
                  <el-upload accept=".mp3" :action="getUrl('AUDIO')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleAudioSuccess"
                    :before-upload="beforeAudioUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                      您可以上传mp3格式的音频文件,文件大小不能超过50M</div>
                    <span
                      style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                      slot="tip" class="el-upload__tip1">
                      请待进度条走到100%并出现
                    </span>
                    <span>
                      <i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                    </span>
                    <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                      class="el-upload__tip">
                      之后保存，方为上传成功
                    </span>
                  </el-upload>
                </el-form-item>
                <el-row style="margin-top: 30px">
                  <el-col :span="8">
                    <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                      <el-input v-model="audio.min" @input="imposeM(audio.min, 'audio')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">分钟</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                      <el-input v-model="audio.miao" @input="impose(audio.miao, 'audio')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">秒</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="tab === '幻灯片'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="ppt.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="ppt.desc" :rows="4"></el-input>
                </el-form-item>

                <el-form-item label="上传文件(PPT格式)" ref="ppt" class="a_upload_file upload_star" prop="id">
                  <!--                                    <ladel slot="label" name="label">-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">上传文件</p>-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">(PPT格式)</p>-->
                  <!--                                    </ladel>-->

                  <el-upload ref="pptUpload" accept=".ppt,.pptx" :action="getUrl('SLIDE')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePPTSuccess"
                    :before-upload="beforePPTUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList2">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">请上传PPT格式的幻灯片文件,
                      文件大小不能超过50M</div>
                    <span
                      style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                      slot="tip" class="el-upload__tip1">
                      请待进度条走到100%并出现
                    </span>
                    <span>
                      <i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                    </span>
                    <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                      class="el-upload__tip">
                      之后保存，方为上传成功
                    </span>
                  </el-upload>
                </el-form-item>
                <el-form-item label="上传文件(PDF格式)" ref="pdf" class="a_upload_file upload_star" style="margin-top: 10px"
                  prop="pdfId">
                  <!--                                    <ladel slot="label">-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">上传文件</p>-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">(PDF格式)</p>-->
                  <!--                                    </ladel>-->
                  <el-upload accept=".pdf" :action="getUrl('SLIDE')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                    :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">请上传PDF格式的幻灯片文件,
                      文件大小不能超过50M</div>
                    <span
                      style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                      slot="tip" class="el-upload__tip1">
                      请待进度条走到100%并出现
                    </span>
                    <span>
                      <i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                    </span>
                    <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                      class="el-upload__tip">
                      之后保存，方为上传成功
                    </span>
                  </el-upload>
                </el-form-item>
              </div>

              <div v-if="tab === '文档'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="doc.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="doc.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="doc" class="a_upload_file upload_star" prop="pdfId">
                  <el-upload accept=".pdf" :action="getUrl('DOCUMENT')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                    :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">请上传PDF格式的幻灯片文件,
                      文件大小不能超过50M</div>
                    <span
                      style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                      slot="tip" class="el-upload__tip1">
                      请待进度条走到100%并出现
                    </span>
                    <span>
                      <i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                    </span>
                    <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                      class="el-upload__tip">
                      之后保存，方为上传成功
                    </span>
                  </el-upload>
                </el-form-item>
              </div>
              <!-- fuckkk -->
              <div v-if="tab === '图库'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="pic.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="pic.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
                  <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleImgSuccess"
                    :before-upload="beforeImgUpload" :file-list="fileList">
                    <i class="el-icon-plus"></i>
                  </el-upload>

                  <p :class="$style.tip">你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                  <p :class="$style.tip" style="color: #4A90E2;font-weight: bold;">
                    请待进度条走到 100%并出现<i class="el-icon-circle-check"
                      style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
                  </p>
                </el-form-item>
              </div>

              <div v-if="tab === '图文'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="text.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="text.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" class="a_upload_file upload_star" prop="id">
                  <Editor @html="handleHtmlChange" :text="ht" />
                </el-form-item>
              </div>

              <div v-if="tab === 'HTML5'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="html5.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="html5.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="启动文件名" class="a_upload_file">
                  <el-input v-model="html5.name" placeholder="请输入内容"></el-input>
                  <p :class="$style.tip">请说明用于启动的HTML文件的名称</p>
                </el-form-item>
                <el-form-item label="上传文件" class="a_upload_file upload_star" style="margin-top: -20px" prop="id">
                  <!--:before-remove="beforeRemove"-->
                  <el-upload accept="application/zip,application/x-zip,application/x-zip-compressed" class="upload-demo"
                    :action="getUrl('BLOG')" :on-preview="handlePreview" :on-remove="handleRemove"
                    :on-success="handleZipSuccess" :before-upload="beforeZipUpload" multiple :limit="2"
                    :on-exceed="handleExceed" :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">请将HTML文件打包成单个ZIP格式后上传, ZIP文件大小不能超过100M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible3" width="60%" :show-close="false" :close-on-click-modal="false">
        <div style="margin-top: -40px;">
          <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
            <el-col :span="9">
              <div style="color: #3998F7;padding-top: 8px;font-size: 22px">编辑资料</div>
            </el-col>
            <el-col :span="15">
              <div v-if="tab === '图文'" style="width: 345px;display: inline-block">
                <div>
                  <span style="color: #FF9901">最后发布日期 </span><span style="color:#87909A">2019-10-18</span>
                  <el-button size="mini" type="warning">正式发布</el-button>
                  <el-button size="mini" type="success">效果预览</el-button>
                </div>
              </div>
              <div v-if="tab === 'HTML5'" style="width: 345px;display: inline-block">
                <div>
                  <span style="color: #FF9901">最后发布日期 </span><span style="color:#87909A">2019-10-18</span>
                  <el-button size="mini" type="warning">正式发布</el-button>
                  <el-button size="mini" type="success">效果预览</el-button>
                </div>
              </div>
              <div align="right" style="width: 28%;float: right;display: inline-block">
                <el-button type="primary" size="small" :disabled="!canUpload" @click="submitForm('edit')">
                  保存
                </el-button>
                <el-button type="danger" size="small" @click="quxiao">
                  取消
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div class="subjectList" style="margin-top: 20px;">
            <el-form ref="form" label-width="100px" class="myElForm demo-ruleForm" :model="onModelType()" :rules="rules"
              hide-required-asterisk>
              <el-form-item label="类型">
                <el-radio-group :disabled="!canUpload" v-model="type" @change="handleTypeChange(type, false)">
                  <el-radio label="视频" :disabled="fileNull ? tab != '视频' : false"></el-radio>
                  <!-- <el-radio label="音频" :disabled="fileNull ? tab != '音频' : false"></el-radio> -->
                  <el-radio label="幻灯片" :disabled="fileNull ? tab != '幻灯片' : false"></el-radio>
                  <el-radio label="文档" :disabled="fileNull ? tab != '文档' : false"></el-radio>
                  <el-radio label="图库" :disabled="fileNull ? tab != '图库' : false"></el-radio>
                  <!--                                    <el-radio label="图文" :disabled="(fileNull?(tab!='图文'):false)"></el-radio>-->
                  <!--                                    <el-radio label="HTML5" :disabled="(fileNull?(tab!='HTML5'):false)"></el-radio>-->
                </el-radio-group>
              </el-form-item>

              <div v-if="tab === '视频'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="video.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="video.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="video" class="a_upload_file upload_star" prop="id">
                  <el-upload accept=".mp4" :action="getUrl('VIDEO')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleVideoSuccess"
                    :before-upload="beforeVideoUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">您可以上传mp4格式的视频文件,文件大小不能超过100M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
                <el-row style="margin-top: 30px">
                  <el-col :span="8">
                    <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                      <el-input v-model="video.min" @input="imposeM(video.min, 'video')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">分钟</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                      <el-input v-model="video.miao" @input="impose(video.miao, 'video')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">秒</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="tab === '音频'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="audio.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="audio.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="audio" class="a_upload_file upload_star" prop="id">
                  <el-upload accept=".mp3" :action="getUrl('AUDIO')" ref="upload" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleAudioSuccess"
                    :before-upload="beforeAudioUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">您可以上传mp3格式的音频文件,文件大小不能超过50M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
                <el-row style="margin-top: 30px">
                  <el-col :span="8">
                    <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                      <el-input v-model="audio.min" @input="imposeM(audio.min, 'audio')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">分钟</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                      <el-input v-model="audio.miao" @input="impose(audio.miao, 'audio')" style="width: 100px"
                        type="number"></el-input>
                      <span :class="$style.font">秒</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="tab === '幻灯片'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="ppt.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="ppt.desc" :rows="4"></el-input>
                </el-form-item>

                <el-form-item label="上传文件(PPT格式)" ref="ppt" class="a_upload_file upload_star" prop="id">
                  <!--                                    <ladel slot="label">-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">上传文件</p>-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">(PPT格式)</p>-->
                  <!--                                    </ladel>-->

                  <el-upload ref="pptUpload" accept=".ppt,.pptx" :action="getUrl('SLIDE')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePPTSuccess"
                    :before-upload="beforePPTUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList2">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">请上传PPT格式的幻灯片文件, 文件大小不能超过50M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="上传文件(PDF格式)" ref="pdf" class="a_upload_file upload_star" style="margin-top: 10px"
                  prop="pdfId">
                  <!--                                    <ladel slot="label">-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">上传文件</p>-->
                  <!--                                        <p style="margin: 0;height: 16px;text-align: center;width: 102px">(PDF格式)</p>-->
                  <!--                                    </ladel>-->
                  <el-upload accept=".pdf" :action="getUrl('SLIDE')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                    :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">请上传PDF格式的幻灯片文件, 文件大小不能超过50M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

              <div v-if="tab === '文档'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="doc.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="doc.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="doc" class="a_upload_file upload_star" prop="pdfId">
                  <el-upload accept=".pdf" :action="getUrl('DOCUMENT')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                    :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">请上传PDF格式的幻灯片文件, 文件大小不能超过50M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

              <div v-if="tab === '图库'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="pic.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="pic.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
                  <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleImgSuccess"
                    :before-upload="beforeImgUpload" :file-list="fileList">
                    <i class="el-icon-plus"></i>
                  </el-upload>

                  <p :class="$style.tip">你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                  <p :class="$style.tip" style="color: #4A90E2;font-weight: bold;">
                    请待进度条走到 100%并出现<i class="el-icon-circle-check"
                      style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px;"></i>之后保存，方为上传成功!
                  </p>
                </el-form-item>
              </div>

              <div v-if="tab === '图文'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="text.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="text.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="上传文件" class="a_upload_file upload_star" prop="id">
                  <Editor @html="handleHtmlChange" :text="ht" />
                </el-form-item>
              </div>

              <div v-if="tab === 'HTML5'">
                <el-form-item label="标题" prop="title" class="upload_star">
                  <el-input v-model="html5.title"></el-input>
                </el-form-item>
                <el-form-item label="简介">
                  <el-input type="textarea" v-model="html5.desc" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="启动文件名" class="a_upload_file upload_star" prop="id">
                  <el-input v-model="html5.name" placeholder="请输入内容"></el-input>
                  <p :class="$style.tip">请说明用于启动的HTML文件的名称</p>
                </el-form-item>
                <el-form-item label="上传文件" class="a_upload_file" style="margin-top: -20px">
                  <el-upload accept=".zip" class="upload-demo" :action="getUrl('BLOG')" :on-preview="handlePreview"
                    :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleZipSuccess"
                    :before-upload="beforeZipUpload" multiple :limit="2" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary" :disabled="!canUpload">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">请将HTML文件打包成单个ZIP格式后上传, ZIP文件大小不能超过100M</div>
                    <div style="margin-top: -10px;" slot="tip" class="el-upload__tip">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px"></i>之后保存，方为上传成功
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" style="position: relative; z-index: 9999" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "../../components/pagination";
  import http from "../../APIService/http";
  import { bus } from "../../router/index.js";
  import Editor from "./components/etitor";
  import http2 from "../../APIService/http2";

  export default {
    data() {
      return {
        fileNull: true,
        rules: {
          miao: [{ required: true, message: "不能为空", trigger: "blur" }],
          picsUrls: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          id: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          pdfId: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        },
        imgUrls: [],
        canUpload: true,
        fileList: [],
        fileList2: [],
        dialogImageUrl: "",
        dialogVisible: false,
        userId: "",
        uid: "",
        dialogVisible2: false,
        dialogVisible3: false,
        ht: "",
        type: "视频",
        tab: "视频",
        video: {
          title: "",
          desc: "",
          videoUrl: "",
          min: "",
          miao: "",
          id: "", // 视频id
          type: "",
          fileName: "",
        },
        audio: {
          title: "",
          desc: "",
          audioUrl: "",
          min: "",
          miao: "",
          id: "", // 音频id
          type: "",
          fileName: "",
        },
        ppt: {
          title: "",
          desc: "",
          pptUrl: "",
          pdfUrl: "",
          pptSize: 0,
          pdfSize: 0,
          pptFileName: "",
          pdfFileName: "",
          id: "",
          pdfId: "",
          type: "",
          pdfType: "",
        },
        doc: {
          title: "",
          desc: "",
          pdfUrl: "",
          pdfId: "",
          pdfType: "",
          fileName: "",
        },
        pic: {
          title: "",
          desc: "",
          picsUrls: [],
        },
        text: {
          title: "",
          desc: "",
          html: "",
          id: "",
          type: "",
        },
        html5: {
          title: "",
          desc: "",
          name: "",
          zipUrl: "",
          id: "",
          type: "",
          fileName: "",
        },
        ht: "",
        id: "",
        library_id: "",
        list: [],
        Mlist: [],
        Dlist: [],
        Hlist: [],
        Plist: [],
        Tlist: [],
        PPTlist: [],
        statistics: {},
        loading: false,
        tableData: [],
        //                id: '',
        database_info: {
          all_num: 0,
          video_num: 0,
          document_num: 0,
          photo_num: 0,
          other_num: 0,
        },
        resData: {
          userId: window.localStorage["userId"],
        },
        //                detabaseObj:{},

        //                fileObj:{
        //                    file_title : '',
        //                    file_Name : '',
        //                    fileList : []
        //                },
        isEdit: false,
        removeFile: false,
        isUpload: false,

        //                page: {
        //                    current: 1,
        //                    size: 10,
        //                    total: 0
        //                },
      };
    },
    created() {
      this.myfileList();
    },
    mounted() {
      //            this.myfileList()
    },
    watch: {
      tab: function (newV, oldV) {
        if (oldV === "视频" || oldV === "音频") {
          this.$refs["form"].clearValidate();
        }
      },
    },
    components: {
      Pagination,
      Editor,
    },
    computed: {
      //            libraryId() {
      //                this.detabaseObj = this.$store.getters.getDatabase
      //                let library_id = this.detabaseObj.library_id
      //                if (library_id) {
      //                    this.myfileList()
      //                }
      //                return library_id
      //            }
    },
    methods: {
      getUrl(category) {
        // return "/files/uploadfile?tenant_id=" + this.$store.getters.getUser.tenant_id;
        return (
          "/files/uploadfile?tenant_id=" +
          // return "http://localhost:15028/uploadfile?tenant_id="
          this.$store.getters.getUser.tenant_id +
          "&reference_obj=DA_LIBRARY&category=" + category + "&user_id=" +
          this.$store.getters.getUser.user_id
        );
      },
      addData() {
        this.Mlist = [];
        this.list = [];
        this.Plist = [];
        this.PPTlist = [];
        this.Dlist = [];
        this.Tlist = [];
        this.Hlist = [];
        this.dialogVisible2 = true;
      },
      submitForm(type = "dianji2") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (type === "edit") {
              this.edit();
            } else {
              this.dianji2();
            }
          } else {
            // this.$message({
            //     message: '请填写播放时长',
            //     type: 'error'
            // });
            //                        console.log('error submit!!');
            return false;
          }
        });
      },
      onModelType() {
        if (this.tab == "视频") {
          return this.video;
        } else if (this.tab == "音频") {
          return this.audio;
        } else if (this.tab == "幻灯片") {
          return this.ppt;
        } else if (this.tab == "文档") {
          return this.doc;
        } else if (this.tab == "图库") {
          return this.pic;
        } else if (this.tab == "图文") {
          return this.text;
        } else if (this.tab == "html5") {
          return this.html5;
        }
      },
      dianji2() {
        this.dialogVisible2 = false;
        let obj = {
          title: "",
          file_type: "",
        };

        if (this.tab === "视频") {
          obj.title = this.video.title;
          obj.file_type = this.video.desc;
        } else if (this.tab === "音频") {
          obj.title = this.audio.title;
          obj.file_type = this.audio.desc;
        } else if (this.tab === "幻灯片") {
          obj.title = this.ppt.title;
          obj.file_type = this.ppt.desc;
        } else if (this.tab === "文档") {
          obj.title = this.doc.title;
          obj.file_type = this.doc.desc;
        } else if (this.tab === "图库") {
          obj.title = this.pic.title;
          obj.file_type = this.pic.desc;
        } else if (this.tab === "图文") {
          obj.title = this.text.title;
          obj.file_type = this.text.desc;
        } else if (this.tab === "HTML5") {
          obj.title = this.html5.title;
          obj.file_type = this.html5.desc;
          obj.comments = this.html5.name;
        }
        this.tableData.push(obj);

        if (this.tab === "视频") {
          this.videolist();
        } else if (this.tab === "音频") {
          this.audiolist();
        } else if (this.tab === "幻灯片") {
          this.pptlist();
        } else if (this.tab === "文档") {
          this.doclist();
        } else if (this.tab === "图库") {
          this.piclist();
        } else if (this.tab === "图文") {
          this.textlist();
        } else if (this.tab === "HTML5") {
          this.html5list();
        }

        //                this.video = {}
        //                this.audio = {}
        //                this.ppt = {}
        //                this.doc = {}
        //                this.pic = {
        //                    title: '',
        //                    desc: '',
        //                    picsUrls: [],
        //                }
        //                this.text = {}
        //                this.html5 = {}

        this.quxiao();
        this.arraylist();
      },

      dianji() {
        this.dialogVisible2 = false;
        this.video = {};
        this.audio = {};
        this.ppt = {};
        this.doc = {};
        this.pic = {
          title: "",
          desc: "",
          picsUrls: [],
        };
        this.text = {};
        this.html5 = {};
      },
      //视频
      //            handleRemove(file, fileList) {
      //                this.fileList=fileList
      //
      //                console.log(file, fileList);
      //            },
      handlePreview(file) {
        console.log(file);
      },
      //            handleRemove(file, fileList) {
      //
      //                this.removeFile = true
      //                this.isUpload = false
      //            },
      handleExceed(files, fileList) {
        this.$message.warning(`当前已存在一个文件，请先删除该文件`);
        //`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      //图片
      handleRemove(file, fileList) {
        console.log(file, fileList);
        if (
          file.file_type === "application/x-ppt" ||
          file.file_type === "application/vnd.ms-powerpoint" ||
          file.file_type === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        ) {
          this.fileList2 = fileList;
        } else {
          this.fileList = fileList;
        }
        if (fileList.length === 0) {
          this.fileNull = false;
          this.pic.picsUrls = [];
          this.video.id = "";
          this.audio.id = "";
          this.doc.pdfId = "";
          this.ppt.id = "";
        }

        for (var i = 0; i < this.pic.picsUrls.length; i++) {
          var pic = this.pic.picsUrls[i];
          if (pic.id == file.response.data.id) {
            this.pic.picsUrls.splice(i, 1);
            return;
          }
        }
      },
      handlePictureCardPreview(file) {

        console.log(JSON.stringify(file))
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 视频上传成功
      handleVideoSuccess(res, file, fileList) {
        console.log("----------------res----------")
        console.log(res);
        console.log("----------------file----------")
        console.log(file);
        console.log("----------------fileList----------")
        console.log(fileList);
        this.canUpload = true;
        if (res.success === true) {
          this.video.videoUrl = res.data.url;
          this.video.id = res.data.s3filename;
          this.video.fileName = file.name;
          //                    this.Mlist.push(res.data)

          this.Mlist = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.Mlist.push(obj);
              if (this.Mlist.length > 1) {
                this.Mlist.shift();
              }
            }
          });
          if (fileList.length > 1) {
            fileList.shift();
          }
          this.fileNull = true;
          this.$refs["video"].clearValidate();
        } else {
          this.fileNull = true;
          this.error("上传文件失败");
        }
      },
      // 视频上传前的验证
      beforeVideoUpload(file) {
        this.fileNull = false;
        const isMp4 = file.type === "video/mpeg4" || file.type === "video/mp4";
        const isLt100M = file.size / 1024 / 1024 < 100 * 1.2;
        this.file_size = file.size;
        if (!isMp4) {
          this.error("上传的文件只能是 mp4 格式!");
        }
        if (!isLt100M) {
          this.error("上传的文件大小不能超过 100MB!");
        }
        const nameArr = file.name.split(".");
        this.video.type = nameArr[nameArr.length - 1];
        var b = isMp4 && isLt100M;

        if (b) {
          this.canUpload = false;
        }

        return b;
      },
      // 音频上传成功
      handleAudioSuccess(res, file, fileList) {
        this.canUpload = true;
        if (res.success === true) {
          this.audio.audioUrl = res.data.url;
          this.audio.id = res.data.s3filename;
          this.audio.fileName = file.name;
          this.list = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.list.push(obj);
              if (this.list.length > 1) {
                this.list.shift();
              }
            }
          });

          //                    this.fileList.shift()
          if (fileList.length > 1) {
            fileList.shift();
          }
          this.$refs["audio"].clearValidate();
        } else {
          this.error("上传失败");
        }
      },
      // 音频上传前的验证
      beforeAudioUpload(file) {
        console.log(file.type)
        debugger;
        const isMp3 = file.type === "audio/mp3" || file.type === "audio/mpeg";
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        this.file_size = file.size;

        if (!isMp3) {
          this.error("上传的文件只能是 mp3 格式!");
        }
        if (!isLt50M) {
          this.error("上传的文件大小不能超过 50MB!");
        }
        const nameArr = file.name.split(".");
        this.audio.type = nameArr[nameArr.length - 1];

        var b = isMp3 && isLt50M;

        if (b) {
          this.canUpload = false;
        }
        return b;
      },
      // 幻灯片上传成功
      handlePPTSuccess(res, file, fileList) {
        this.canUpload = true;

        if (res.success === true) {
          this.ppt.pptSize = file.size;
          this.ppt.pptFileName = file.name;
          this.ppt.id = res.data.s3filename;

          this.PPTlist = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.PPTlist.push(obj);
              if (this.PPTlist.length > 1) {
                this.PPTlist.shift();
              }
            }
          });
          if (fileList.length > 1) {
            fileList.shift();
          }
          this.$refs["ppt"].clearValidate();
        } else {
          this.error("上传失败");
        }
      },
      // 幻灯片上传前的验证
      beforePPTUpload(file) {
        let suffix = file.name.split(".").pop();
        // const isPPT = file.type === 'application/x-ppt' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        const isPPT = suffix === "ppt" || suffix === "pptx";
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        const nameArr = file.name.split(".");
        this.ppt.type = nameArr[nameArr.length - 1];
        if (suffix) {
          if (!isPPT) {
            this.error("上传的文件只能是 ppt 格式!");
            // this.$refs.ppt.abort()
          }
        } else {
          this.error("上传的文件只能是 ppt 格式,请清除文件!");
          this.$refs.pptUpload.abort();
          return;
        }
        if (!isLt50M) {
          this.error("上传的文件大小不能超过 50MB!");
        }

        var b = isPPT && isLt50M;

        if (b) {
          this.canUpload = false;
        }
        return b;
        //return isPPT && isLt50M
      },
      // pdf上传成功
      handlePDFSuccess(res, file, fileList) {
        this.canUpload = true;
        const isPPT =
          file.type === "application/x-ppt" ||
          file.type === "application/vnd.ms-powerpoint" ||
          file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        this.file_size = file.size;
        if (res.success === true) {
          if (this.tab === "幻灯片") {
            this.ppt.pdfUrl = res.data.url;
            this.ppt.pdfId = res.data.s3filename;
            this.ppt.pdfSize = file.size;
            this.ppt.pdfFileName = file.name;
            //                        this.Plist = (res.data)

            this.Plist = [];
            fileList.forEach((item) => {
              if (item.response) {
                let obj = {
                  file_id: item.response.data.s3filename,
                  file_name: item.response.data.filename,
                  file_type: item.response.data.filetype,
                  file_size: item.response.data.filesize,
                };
                this.Plist.push(obj);
                if (this.Plist.length > 1) {
                  this.Plist.shift();
                }
              }
            });
            if (fileList.length > 1) {
              fileList.shift();
            }
            this.$refs["pdf"].clearValidate();
          } else if (this.tab === "文档") {
            this.doc.fileName = file.name;
            this.doc.pdfId = res.data.s3filename;
            //                        this.Dlist.push(res.data)

            this.Dlist = [];
            fileList.forEach((item) => {
              if (item.response) {
                let obj = {
                  file_id: item.response.data.s3filename,
                  file_name: item.response.data.filename,
                  file_type: item.response.data.filetype,
                  file_size: item.response.data.filesize,
                };
                this.Dlist.push(obj);
                if (this.Dlist.length > 1) {
                  this.Dlist.shift();
                }
              }
            });
            if (fileList.length > 1) {
              fileList.shift();
            }
            this.$refs["doc"].clearValidate();
          }
        } else {
          this.error("上传失败");
        }
      },
      // pdf上传前的验证
      beforePDFUpload(file) {
        const isPdf = file.type === "application/pdf";
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        this.file_size = file.size;

        if (!isPdf) {
          this.error("上传的文件只能是 pdf 格式!");
        }
        if (!isLt50M) {
          this.error("上传的文件大小不能超过 50MB!");
        }
        if (this.type === "幻灯片") {
          const nameArr = file.name.split(".");
          this.ppt.pdfType = nameArr[nameArr.length - 1];
        } else if (this.type === "文档") {
          const nameArr = file.name.split(".");
          this.doc.pdfType = nameArr[nameArr.length - 1];
        }

        var b = isPdf && isLt50M;

        if (b) {
          this.canUpload = false;
        }
        return b;
        //return isPdf && isLt50M
      },
      // 上传图片成功
      handleImgSuccess(res, file) {
        debugger;
        console.log("----------------res----------")
        console.log(res);
        console.log("----------------file----------")
        console.log(file);
        if (res.success === true) {
          this.pic.picsUrls[this.pic.picsUrls.length - 1].id = res.data.s3filename;
          this.pic.picsUrls[this.pic.picsUrls.length - 1].url = res.data.url;
          this.pic.picsUrls[this.pic.picsUrls.length - 1].size = file.size;
          this.pic.picsUrls[this.pic.picsUrls.length - 1].fileName = file.name;
          this.Tlist.push(res.data);
          this.$refs.picUpload.clearValidate();
        } else {
          this.error("上传失败");
        }
        console.log(this.pic)
      },
      // 上传图片前的验证
      beforeImgUpload(file) {
        debugger
        console.log(JSON.stringify(file))
        const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
        const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
        this.file_size = file.size;

        if (!isPic) {
          this.error("上传图片只能是 jpg 或png 格式!");
        }
        if (!isLt20M) {
          this.error("上传图片大小不能超过 20MB!");
        }
        const nameArr = file.name.split(".");
        console.log(nameArr)
        this.pic.picsUrls.push({ type: nameArr[nameArr.length - 1], status: "success" });
        console.log("----------pic----");
        console.log(JSON.stringify(this.pic));
        return isPic && isLt20M;
      },
      // 富本框
      handleHtmlChange(html) {
        this.text.html = html;
        this.text.type = "blog";
      },
      //zip上传成功
      handleZipSuccess(res, file, fileList) {
        this.canUpload = true;

        if (res.success === true) {
          this.html5.zipUrl = res.data.url;
          this.html5.id = res.data.id;
          this.html5.fileName = file.name;
          //                    this.Hlist.push(res.data)

          this.Hlist = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.Hlist.push(obj);
              if (this.Hlist.length > 1) {
                this.Hlist.shift();
              }
            }
          });
          if (fileList.length > 1) {
            fileList.shift();
          }
        } else {
          this.error("上传失败");
        }
      },
      // zip 上传前的验证
      beforeZipUpload(file) {
        const isZip = file.type === "application/zip";
        const isLt100M = file.size / 1024 / 1024 < 100 * 1.2;
        this.file_size = file.size;

        if (!isZip) {
          this.error("请将文件打包成zip格式再上传!");
        }
        if (!isLt100M) {
          this.error("上传文件大小不能超过 100MB!");
        }
        const nameArr = file.name.split(".");
        this.html5.type = nameArr[nameArr.length - 1];
        var b = isZip && isLt100M;

        if (b) {
          this.canUpload = false;
        }
        return b;
        //return isZip && isLt100M
      },

      //类型转换
      handleTypeChange(value, isEdit) {
        this.$refs["form"].clearValidate();
        this.fileList = [];
        this.fileList2 = [];
        if (value === "视频") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = '视频'
          //                    this.type = '视频'
          this.video.videoUrl = " ";
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}

          //                    if (this.video/){
          // this.video={}
          //                    }
          //                    this.fileList = [{name:o.fileName, url: o.src}]
        } else if (value === "音频") {
          this.quxiao(false, value, isEdit);
          //
          //                    this.tab = '音频'
          //                    this.type = '音频'
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
        } else if (value === "幻灯片") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = '幻灯片'
          //                    this.type = '幻灯片'

          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
          this.pdfUrl = this.ppt.pdfUrl;
        } else if (value === "文档") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = '文档'
          //                    this.type = '文档'
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
          this.pdfUrl = this.doc.pdfUrl;
        } else if (value === "图库") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = '图库'
          //                    this.type = '图库'
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
        } else if (value === "图文") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = '图文'
          //                    this.type = '图文'
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
        } else if (value === "HTML5") {
          this.quxiao(false, value, isEdit);
          //                    this.tab = 'HTML5'
          //                    this.type = 'HTML5'
          //                    this.video = {}
          //                    this.audio = {}
          //                    this.ppt = {}
          //                    this.doc = {}
          //                    this.pic = {
          //                        title: '',
          //                        desc: '',
          //                        picsUrls: [],
          //                    }
          //                    this.text = {}
          //                    this.html5 = {}
        }
      },
      isFileType(type) {
        switch (type) {
          case "PICTURE":
            return "图库";
            break;
          case "AUDIO":
            return "音频";
            break;
          case "VIDEO":
            return "视频";
            break;
          case "SLIDE":
            return "幻灯片";
            break;
          case "DOCUMENT":
            return "文档";
            break;
          case "BLOG":
            return "图文";
            break;
          case "HTML5":
            return "HTML5";
            break;
        }
      },

      async videolist() {
        try {
          let array2 = [...this.Mlist];

          let json2 = JSON.stringify(array2);

          if (this.video.min === "") {
            this.video.min = 0;
          }
          if (this.video.miao === "") {
            this.video.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.video.title,
            sub_title: this.video.desc,
            comments: "",
            category: "VIDEO",
            duration: parseInt(this.video.min) * 60 + parseInt(this.video.miao), //播放时长
            files: json2,
          };
          console.log("---------------VIDEO-----------");
          console.log(data);
          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            console.log(res.data);
            if (res.success) {
              this.Mlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async audiolist() {
        try {
          let array = [...this.list];

          let json = JSON.stringify(array);
          //                    this.$store.getters.getDatabase.library_id
          //                    this.$store.getters.getDatabase.catalog_id
          if (this.audio.min === "") {
            this.audio.min = 0;
          }
          if (this.audio.miao === "") {
            this.audio.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.audio.title,
            sub_title: this.audio.desc,
            comments: "",
            category: "AUDIO",
            duration: parseInt(this.audio.min) * 60 + parseInt(this.audio.miao), //播放时长
            files: json,
          };

          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.list = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async myfileList(isy) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            id: this.$route.query.catalog_id,
          };

          // this.loading = true;
          await http.post("/wapi/dataBank/fileList", data).then((res) => {
            debugger;
            this.loading = false;
            // console.log(res)
            this.tableData = res.data;
            let obj = {
              imgNum: 0,
              docNum: 0,
              mp4Num: 0,
              restsNum: 0,
            };
            res.data.forEach((item) => {
              if (item.category == "PICTURE") {
                obj.imgNum++;
              } else if (item.category == "VIDEO") {
                obj.mp4Num++;
              } else if (item.category == "DOCUMENT") {
                obj.docNum++;
              } else {
                obj.restsNum++;
              }
            });
            this.statistics = obj;
          });
        } catch (err) {
          this.loading = false;
        }
      },

      async arraylist() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
          };

          await http.post("/wapi/dataBank/list", data).then((res) => {
            //                    console.log(res.data)
            this.library_id = res.data.library_id;

            this.folderArry = res.data.list;
            this.loading = false;
          });
        } catch (err) {
          this.loading = false;
        }
      },
      async pptlist() {
        try {
          let array4 = [...this.Plist, ...this.PPTlist];

          let json4 = JSON.stringify(array4);

          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.ppt.title,
            sub_title: this.ppt.desc,
            duration: 0,
            comments: "",
            category: "SLIDE",
            files: json4,
          };
          debugger;
          console.log("---------------ppt-----------");
          console.log(data);
          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            if (res.success) {
              this.PPTlist = [];
              this.Plist = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async doclist() {
        try {
          let array3 = [...this.Dlist];

          let json3 = JSON.stringify(array3);

          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.doc.title,
            sub_title: this.doc.desc,
            duration: 0,
            comments: "",
            category: "DOCUMENT",
            files: json3,
          };

          console.log("---------------DOCUMENT-----------");
          console.log(data);
          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Dlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },

      async piclist() {
        try {
          let array5 = [];
          this.Tlist.forEach((item) => {
            let obj5 = {
              file_id: item.s3filename,
              file_name: item.filename,
              file_type: item.filetype,
              file_size: item.filesize,
            };
            array5.push(obj5);
          });
          let json5 = JSON.stringify(array5);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.pic.title,
            sub_title: this.pic.desc,
            duration: 0,
            comments: "",
            category: "PICTURE",
            files: json5,
          };
          console.log("---------------PICTURE-----------");
          console.log(data);
          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Tlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },

      //            async textlist(){
      //                try {
      //                    let data={
      //                        tenant_id: this.$store.getters.getUser.tenant_id,//必填
      //                        user_id: this.$store.getters.getUser.user_id,//必填
      //                        library_id:  this.$store.getters.getDatabase.library_id,//必填
      //                        catalog_id:this.$route.query.catalog_id,//必填（文件夹id）
      //                        title: this.text.title,
      //                        sub_title:this.text.desc,
      //                        duration:0,
      //                        comments:'',
      //                        category: "BLOG",
      //                        files:{}
      //                    }
      //                    await http.post("/wapi/dataBank/addFile",data).then(res=>{
      //                        console.log(res)
      //                    })
      //                }catch (err) {
      //                    this.error()
      //                }
      //            },
      async html5list() {
        try {
          let array7 = [...this.Hlist];

          let json7 = JSON.stringify(array7);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.$store.getters.getDatabase.library_id, //必填
            catalog_id: this.$route.query.catalog_id, //必填（文件夹id）
            title: this.html5.title,
            sub_title: this.html5.desc,
            comments: this.html5.name,
            category: "HTML5",
            duration: 0, //播放时长
            files: json7,
          };

          console.log("---------------HTML5-----------");
          console.log(data);
          await http.post("/wapi/dataBank/addFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Hlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },

      //            async init() {
      //                try {
      //
      //                    this.loading = true
      //
      //                    let data = {
      //                        limit: this.page.size,
      //                        offset: this.page.current - 1,
      //                        tenant_id: this.$store.getters.getUser.tenant_id,
      //                        user_id: this.$store.getters.getUser.user_id,
      //                        library_id:this.detabaseObj.library_id,
      //                        catalog_id:this.detabaseObj.catalog_id
      //                    }
      //                    this.tableData = []
      //
      //                    await http.post('/wapi/v1/getFileList', data).then(res => {
      //
      //                        // this.page.total = res.data.total
      //
      //                        this.tableData = res.data.result_array
      //
      //                        this.database_info = res.data.database_info
      //
      //                        this.loading = false
      //
      //
      //                    })
      //                } catch (err) {
      //                    this.loading = false
      //                    //this.error()
      //                }
      //            },
      async setStatus(row) {
        try {
          this.loading = true;

          let status = "ACTIVE";
          if (row.status === "ACTIVE") {
            status = "INACTIVE";
          } else {
            status = "ACTIVE";
          }

          let json2 = JSON.stringify(row.files);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: row.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: row.title,
            sub_title: row.sub_title,
            status: status,
            category: row.category,
            duration: row.duration,
            comments: "",
            files: json2,
          };

          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            // this.page.total = res.data.total

            let success = res.success;

            if (success) {
              if (row.status === "ACTIVE") {
                row.status = "INACTIVE";
                row.status = "关闭";
              } else {
                row.status = "ACTIVE";
                row.status = "启用";
              }

              this.Mlist;
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }

            this.loading = false;
          });
        } catch (err) {
          this.loading = false;
          this.error();
        }
      },
      async getImgUrl(file_id) {
        try {
          this.loading = true;
          let url = "";

          let Body = new FormData();
          Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
          Body.append("file_ids", file_id);
          Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
          Body.append("reference_obj", "CLIENT");
          Body.append("reference_id", "com.saasyun.android");

          var config = {
            headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
          }; //添加请求头
          let data = {
            credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
            file_ids: file_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            reference_obj: "CLIENT",
            reference_id: "com.saasyun.android",
            headersContentType: "multipart/form-data",
          };
          debugger;
          let res = await http
            .post("/files/downloadfiles", data) //
            // let res = await http.post('http://localhost:15028/downloadfiles', Body, config)//
            .then((response) => {
              if (response.success) {
                //                                    this.imgUrls.push(response.data[0].url)
                //                                    return new Promise((resolve, reject) => {
                //                                        resolve(response.data[0].url)
                //                                    })
                url = response.data[0].url;
              }
            });

          this.loading = false;
          return url;
        } catch (err) {
          this.loading = false;
          //                    this.error()
        }
      },
      async downloadFile(row) {
        try {
          this.loading = true;

          debugger;
          //                    let Body = {
          //                        credential: '58f09f86-694c-472d-bb63-64f9be093fd2',
          //                        file_ids: row.files[0].file_id,
          //                        tenant_id: this.$store.getters.getUser.tenant_id,
          //                        reference_obj: 'CLIENT',
          //                        reference_id: 'com.saasyun.android'
          //                    }

          for (let i = 0; i < row.files.length; i++) {
            let Body = new FormData();
            Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
            Body.append("file_ids", row.files[i].file_id);
            Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
            Body.append("reference_obj", "CLIENT");
            Body.append("reference_id", "com.saasyun.android");

            var config = {
              headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
            }; //添加请求头
            let data = {
              credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
              file_ids: row.files[i].file_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              reference_obj: "CLIENT",
              reference_id: "com.saasyun.android",
              headersContentType: "multipart/form-data",
            };
            debugger;
            await http
              .post("/files/downloadfiles", data) //
              .then((response) => {
                if (response.success) {
                  //                                this.savaFileId(response.data)
                  //                                window.open(response.data[0].url)
                  //                                let  a = document.createElement('a');
                  //                                a.href=response.data[0].url;
                  //                                a.download=row.title
                  //                                a.target='_blank'
                  //                                a.click()
                  //                                document.removeChild(a)

                  downloadFile(response.data[0].url);

                  //                                window.location.href=response.data[0].url;
                }
              });
          }

          this.loading = false;
        } catch (err) {
          this.loading = false;
          //                    this.error()
        }
      },
      async handleEdit(index, row) {
        if (row.files.length === 0) {
          this.fileNull = false;
        }
        console.log(index, row);
        if (row.category === "VIDEO") {
          this.tab = "视频";
          this.type = "视频";
          this.video.title = row.title;
          this.video.desc = row.sub_title;
          this.video.min = parseInt(parseInt(row.duration) / 60);
          this.video.miao = parseInt(row.duration) % 60;
          this.key_id = row.key_id;
          this.status = row.status;
          row.files.forEach((item) => {
            item.name = item.file_name;
            item.url = item.file_id;
          });
          this.fileList = row.files;
          this.video.id = row.files[0].file_id;
        } else if (row.category === "AUDIO") {
          this.tab = "音频";
          this.type = "音频";
          this.audio.title = row.title;
          this.audio.desc = row.sub_title;
          this.audio.min = parseInt(row.duration / 60);
          this.audio.miao = row.duration % 60;
          this.key_id = row.key_id;
          this.status = row.status;

          row.files.forEach((item) => {
            if (item.file_id) {
              item.name = item.file_name;
              item.url = item.file_id;
            }
          });
          this.fileList = row.files;
          this.audio.id = row.files[0].file_id;
        } else if (row.category === "DOCUMENT") {
          this.tab = "文档";
          this.type = "文档";
          this.doc.title = row.title;
          this.doc.desc = row.sub_title;
          this.key_id = row.key_id;
          row.files.forEach((item) => {
            item.name = item.file_name;
            item.url = item.file_id;
          });
          this.fileList = row.files;
          this.status = row.status;
          this.doc.pdfId = row.files[0].file_id;
        } else if (row.category === "PICTURE") {
          this.tab = "图库";
          this.type = "图库";
          this.pic.title = row.title;
          this.pic.desc = row.sub_title;
          this.status = row.status;
          this.key_id = row.key_id;
          //                    this.imgUrls=[]
          for (let i = 0; i < row.files.length; i++) {
            row.files[i].name = row.files[i].file_name;

            let url = await this.getImgUrl(row.files[i].file_id);
            row.files[i].url = url;
            this.fileList.push(row.files[i]);
            this.pic.picsUrls.push(row.files[i]);
          }

          //                    row.files.forEach((item,index) => {
          //                        item.name = item.file_name
          //                        item.url = this.imgUrls[index]
          //                    })
          // this.fileList = row.files;
        } else if (row.category === "SLIDE") {
          this.tab = "幻灯片";
          this.type = "幻灯片";
          this.ppt.title = row.title;
          this.ppt.desc = row.sub_title;
          this.status = row.status;
          this.key_id = row.key_id;

          this.fileList = [];
          this.fileList2 = [];
          row.files.forEach((item) => {
            item.name = item.file_name;
            item.url = item.file_id;

            if (item.file_type == "application/pdf") {
              this.fileList.push(item);
            } else {
              this.fileList2.push(item);
            }
          });
          this.ppt.pdfId = row.files[0].file_id;
          this.ppt.id = row.files[0].file_id;
          //                    this.fileList = row.files
        } else if (row.category === "HTML5") {
          this.tab = "HTML5";
          this.type = "HTML5";
          this.html5.title = row.title;
          this.html5.desc = row.sub_title;
          this.html5.name = row.comments;
          this.status = row.status;
          this.key_id = row.key_id;
          row.files.forEach((item) => {
            item.name = item.file_name;
            item.url = item.file_id;
          });
          this.fileList = row.files;
        }

        this.dialogVisible3 = true;
      },
      //                if (num === 0) {
      //                    this.isEdit = false
      //                    this.isUpload = false
      //
      //                    this.fileObj.file_title = '上传文件'
      //                    this.fileName = ''
      //
      //                    this.fileObj.fileList = []
      //                } else {
      //                    this.isEdit = true
      //                    this.removeFile = false
      //                    this.isUpload = true
      //
      //                    this.fileObj = item
      //
      //                    this.fileObj.file_title = '文件详情'
      //                    this.fileName = item.file_name
      //
      //                    this.fileObj.fileList = [{
      //                        name:item.file_name
      //                    }]
      //                }

      async editvideo() {
        try {
          let array2 = [];

          if (this.Mlist.length > 0) {
            array2 = [...this.Mlist];
          } else {
            array2 = [...this.fileList];
          }

          let json2 = JSON.stringify(array2);
          if (this.video.min === "") {
            this.video.min = 0;
          }
          if (this.video.miao === "") {
            this.video.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.video.title,
            sub_title: this.video.desc,
            status: this.status,
            category: "VIDEO",
            duration: parseInt(this.video.min) * 60 + parseInt(this.video.miao),
            comments: "",
            files: json2,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Mlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async editaudio() {
        try {
          let array = [];
          if (this.list.length > 0) {
            array = [...this.list];
          } else {
            array = [...this.fileList];
          }

          let json = JSON.stringify(array);
          if (this.audio.min === "") {
            this.audio.min = 0;
          }
          if (this.audio.miao === "") {
            this.audio.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.audio.title,
            sub_title: this.audio.desc,
            status: this.status,
            category: "AUDIO",
            duration: parseInt(this.audio.min) * 60 + parseInt(this.audio.miao),
            comments: "",
            files: json,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.list = [];
              this.myfileList();
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async editppt() {
        try {
          let array3 = [];

          if (this.Plist.length > 0) {
            array3 = [...this.Plist];
          } else {
            array3 = [...this.fileList];
          }

          if (this.PPTlist.length > 0) {
            array3 = [...array3, ...this.PPTlist];
          } else {
            array3 = [...array3, ...this.fileList2];
          }

          let json3 = JSON.stringify(array3);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.ppt.title,
            sub_title: this.ppt.desc,
            status: this.status,
            category: "SLIDE",
            duration: 0,
            comments: "",
            files: json3,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Plist = [];
              this.PPTlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }
          });
        } catch (err) {
          this.error();
        }
      },

      async editdoc() {
        try {
          let array3 = [];
          if (this.Dlist.length > 0) {
            array3 = [...this.Dlist];
          } else {
            array3 = [...this.fileList];
          }

          let json3 = JSON.stringify(array3);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.doc.title,
            sub_title: this.doc.desc,
            status: this.status,
            category: "DOCUMENT",
            duration: 0,
            comments: "",
            files: json3,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Dlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }
          });
        } catch (err) {
          this.error();
        }
      },

      async editpic() {
        try {
          let array5 = [];
          this.Tlist.forEach((item) => {
            let obj5 = {
              file_id: item.s3filename,
              file_name: item.filename,
              file_type: item.filetype,
              file_size: item.filesize,
            };
            array5.push(obj5);
          });
          array5 = [...array5, ...this.fileList];
          let json5 = JSON.stringify(array5);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.pic.title,
            sub_title: this.pic.desc,
            status: this.status,
            category: "PICTURE",
            duration: 0,
            comments: "",
            files: json5,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Tlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      async edithtml5() {
        try {
          let array7 = [];
          if (this.Hlist.length > 0) {
            array7 = [...this.Hlist];
          } else {
            array7 = [...this.fileList];
          }

          let json7 = JSON.stringify(array7);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            key_id: this.key_id,
            library_id: this.$store.getters.getDatabase.library_id,
            title: this.html5.title,
            sub_title: this.html5.desc,
            status: this.status,
            category: "HTML5",
            duration: 0,
            comments: this.html5.name,
            files: json7,
          };
          await http.post("/wapi/dataBank/editFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.Hlist = [];
              setTimeout(() => {
                this.myfileList();
              }, 100);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      impose(v, t) {
        if (t == "video") {
          if (parseInt(v) > 59) {
            this.video.miao = 59;
          } else if (parseInt(v) < 0) {
            this.video.miao = 0;
          }
        } else if (t == "audio") {
          if (parseInt(v) > 59) {
            this.audio.miao = 59;
          } else if (parseInt(v) < 0) {
            this.audio.miao = 0;
          }
        }
      },
      imposeM(v, t) {
        if (t === "video") {
          if (parseInt(v) < 0) {
            this.video.min = 0;
          }

          if (this.video.miao === "") {
            this.video.miao = 0;
          }
        } else if (t === "audio") {
          if (parseInt(v) < 0) {
            this.audio.min = 0;
          }

          if (this.audio.miao === "") {
            this.audio.miao = 0;
          }
        }
      },
      edit() {
        if (this.tab === "视频") {
          this.editvideo();
        } else if (this.tab === "音频") {
          this.editaudio();
        } else if (this.tab === "文档") {
          this.editdoc();
        } else if (this.tab === "图库") {
          this.editpic();
        } else if (this.tab === "HTML5") {
          this.edithtml5();
        } else if (this.tab === "幻灯片") {
          this.editppt();
        }
        this.$refs["form"].clearValidate();

        this.quxiao();
        this.dialogVisible3 = false;

        //                this.myfileList()
      },
      openDialog() {
        this.$refs["form"].clearValidate();
      },
      quxiao(isy = true, type = "视频", isEdit = true) {
        this.$refs["form"].clearValidate();
        this.tab = type;
        this.type = type;

        if (isEdit) {
          this.key_id = "";
          this.status = "";
          this.fileNull = true;
        }
        this.fileList = [];
        this.Dlist = [];
        this.Mlist = [];
        this.list = [];
        this.Plist = [];

        for (let key in this.video) {
          let item = this.video[key];
          if (item instanceof Array) {
            this.video[key] = [];
          } else if (item instanceof Object) {
            this.video[key] = {};
          } else {
            this.video[key] = "";
          }
        }
        for (let key in this.audio) {
          let item = this.audio[key];
          if (item instanceof Array) {
            this.audio[key] = [];
          } else if (item instanceof Object) {
            this.audio[key] = {};
          } else {
            this.audio[key] = "";
          }
        }
        for (let key in this.ppt) {
          let item = this.ppt[key];
          if (item instanceof Array) {
            this.ppt[key] = [];
          } else if (item instanceof Object) {
            this.ppt[key] = {};
          } else {
            this.ppt[key] = "";
          }
        }
        for (let key in this.doc) {
          let item = this.doc[key];
          if (item instanceof Array) {
            this.doc[key] = [];
          } else if (item instanceof Object) {
            this.doc[key] = {};
          } else {
            this.doc[key] = "";
          }
        }
        for (let key in this.pic) {
          let item = this.pic[key];
          if (item instanceof Array) {
            this.pic[key] = [];
          } else if (item instanceof Object) {
            this.pic[key] = {};
          } else {
            this.pic[key] = "";
          }
        }
        for (let key in this.text) {
          let item = this.text[key];
          if (item instanceof Array) {
            this.text[key] = [];
          } else if (item instanceof Object) {
            this.text[key] = {};
          } else {
            this.text[key] = "";
          }
        }
        for (let key in this.html5) {
          let item = this.html5[key];
          if (item instanceof Array) {
            this.html5[key] = [];
          } else if (item instanceof Object) {
            this.html5[key] = {};
          } else {
            this.html5[key] = "";
          }
        }

        //                this.video = {
        //                    title: '',
        //                    desc: '',
        //                    videoUrl: '',
        //                    min: '',
        //                    miao: "",
        //                    id: '', // 视频id
        //                    type: '',
        //                    fileName: ''
        //                }
        //                this.audio = {
        //                    title: '',
        //                    desc: '',
        //                    audioUrl: '',
        //                    min: '',
        //                    id: '', // 音频id
        //                    type: '',
        //                    fileName: '',
        //                    fileList:[]
        //                }
        //                this.ppt = {
        //                    title: '',
        //                    desc: '',
        //                    pptUrl: '',
        //                    pdfUrl: '',
        //                    pptSize: 0,
        //                    pdfSize: 0,
        //                    pptFileName: '',
        //                    pdfFileName: '',
        //                    id: '',
        //                    pdfId: '',
        //                    type: '',
        //                    pdfType: ''
        //                }
        //                this.doc = {
        //                    title: '',
        //                    desc: '',
        //                    pdfUrl: '',
        //                    pdfId: '',
        //                    pdfType: '',
        //                    fileName: ''
        //                }
        //                this.pic = {
        //                    title: '',
        //                    desc: '',
        //                    picsUrls: [],
        //                }
        //                this.text = {
        //                    title: '',
        //                    desc: '',
        //                    html: '',
        //                    id: '',
        //                    type: ''
        //                }
        //                this.html5 = {
        //                    title: '',
        //                    desc: '',
        //                    name: '',
        //                    zipUrl: '',
        //                    id: '',
        //                    type: '',
        //                    fileName: ''
        //                }

        if (isy) {
          this.dialogVisible3 = false;
          this.dialogVisible2 = false;
        }
      },
      getFileSize(num) {
        let size_text;
        size_text = (parseInt(num) / 1024).toFixed(0); //kb
        if (size_text >= 1024) {
          size_text = (size_text / 1024).toFixed(0); //mb

          size_text = size_text + "MB";
        } else {
          size_text = size_text + "KB";
        }

        return size_text;
      },
      //            changePageClick(page, size) {
      //                if (page) {
      //                    this.page.current = page
      //                }
      //
      //                if (size) {
      //                    this.page.size = size
      //                }
      //                this.init()
      //            },

      //            handChange(file) {
      //                this.isUpload = true
      //            },

      // pdf上传成功
      //            handlePDFSuccess(res, file) {
      //
      //            },
      // pdf上传前的验证
      //            beforePDFUpload(file) {
      //                // const fileType = file.type
      //
      //                const fileSize = file.size / 1024 / 1024 < 200 * 1.2
      //
      //                if (!fileSize) {
      //                    this.error('上传的文件大小不能超过 200MB!')
      //                }
      //
      //                return true
      //            },

      //            uploadFun(param){
      //
      //                if(this.isEdit && !this.removeFile){//有编辑但并未更换文件
      //
      //                    this.savaFileId(this.fileObj)
      //
      //                }else {
      //
      //                    var data = new FormData(); //创建form对象
      //                    data.append('file',param.file);
      //                    data.append('reference_obj','CLIENT');
      //                    data.append('reference_id','com.saasyun.android');
      //                    data.append('credential','58f09f86-694c-472d-bb63-64f9be093fd2');
      //                    data.append('username',this.$store.getters.getUser.username);
      //                    data.append('tenant_id',this.$store.getters.getUser.tenant_id);
      //                    data.append('user_id',this.$store.getters.getUser.user_id);
      //                    // data.append('category','USER');
      //                    // data.append('size','300');
      //                    data.append('bucket','retaium-file');
      //                    data.append('category','LIBRARY');
      //
      //
      //                    var config = {
      //                        headers:{'Content-Type':'multipart/form-data'}
      //                    }; //添加请求头
      //                    http.post(param.action,data,config)//
      //                        .then(response=>{
      //
      //                            if(response.success){
      //
      //                                //如果是编辑并换了文件
      //
      //                                if(this.isEdit && this.removeFile){
      //
      //                                    this.fileObj.old_file_id = this.fileObj.file_id
      //
      //                                }
      //                                const nameArr = response.data.filename.split('.')
      //                                this.fileObj.extension = '.'+ nameArr[nameArr.length-1]
      //
      //                                this.fileObj.file_id = response.data.s3filename
      //                                this.fileObj.file_type = response.data.filetype
      //                                this.fileObj.file_size = response.data.filesize
      //
      //                                this.savaFileId(this.fileObj)
      //
      //                            }
      //                        })
      //                        .catch(({err}) => {
      //
      //                            this.loading = false
      //                        })
      //
      //                }
      //
      //            },
      //            async savaFileId(obj){
      //                let userObj = this.$store.getters.getUser
      //                let detabaseObj = this.$store.getters.getDatabase
      //
      //                let data = {
      //                    tenant_id: userObj.tenant_id,
      //                    user_id: userObj.user_id,
      //                    library_id:detabaseObj.library_id,
      //                    catalog_id:detabaseObj.catalog_id,
      //                    old_file_id:obj.old_file_id,
      //                    file_id:obj.file_id,
      //                    file_name:this.fileName,
      //                    file_type:obj.file_type,
      //                    file_size:obj.file_size,
      //                    extension:obj.extension,
      //                    created_by:userObj.user_id,
      //                    isEdit: this.isEdit,
      //                    removeFile: this.removeFile
      //                }
      //
      //                await http.post('/wapi/v1/savaFileId', data).then(res => {
      //
      //                    let success  = res.success
      //
      //                    if(success){
      //                        this.dialogVisible = false
      //                        this.fileObj.fileList = []
      //
      //                        this.$message({ message: '上传成功!', type: 'success' });
      //                        this.init()
      //                    }
      //
      //                    this.loading = false
      //
      //
      //                })
      //            },
      //            submitFile() {
      //                if(!this.fileName){
      //                    this.$message({ message: '请输入文件名称', type: 'error' });
      //                    return
      //                }
      //                if(!this.isUpload){
      //                    this.$message({ message: '请上传文件', type: 'error' });
      //                    return
      //                }
      //
      //                this.loading = true
      //
      //                if (this.isEdit && !this.removeFile) {//有编辑但并未更换文件
      //
      //                    this.savaFileId(this.fileObj)
      //
      //                } else{
      //                    this.$refs.uploadFile.submit()
      //            }
      //            },
      handleClose(done) {
        this.fileObj.fileList = [];
        this.dialogVisible = false;
        //                this.$confirm('确认关闭？')
        //                    .then(_ => {
        done();
        //                    })
        //                    .catch(_ => {});
      },
    },
    updated() {
      // console.log(this.tableData)
    },
  };

  const downloadFile = (url) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none"; // 防止影响页面
    iframe.style.height = 0; // 防止影响页面
    iframe.src = url;
    document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
    // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
    setTimeout(() => {
      iframe.remove();
    }, 1 * 60 * 1000);
  };
</script>
<style lang="scss" module scoped>
  .container {
    .top {}
  }
</style>
<style scoped>
  .el-button--success {
    background-color: #4ec880;
    border-color: #4ec880;
  }

  .el-button--primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  .el-button--danger {
    background-color: #ed3b3f;
    border-color: #ed3b3f;
  }

  .el-button--warning {
    background-color: #ff9901;
    border-color: #ff9901;
  }

  .subjectList>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
  }
</style>
<style>
  .headerStyle>div {
    font-size: 14px;
    color: #585757;
    font-weight: bold;
  }

  .headerStyle:last-of-type>div {
    color: #4a90e2;
  }

  .myElForm .el-form-item__label {
    font-weight: bold;
    color: black;
  }

  .myelformItem .el-form-item__content {
    margin: 0 !important;
  }

  .el-form-item__content .el-upload__tip:last-of-type {
    color: #4a90e2;
    font-weight: bold;
  }

  .el-form-item__content .el-upload__tip:last-of-type:after {
    content: "!";
  }

  .el-form-item__content .el-upload__tip:last-of-type>.el-icon-circle-check {
    color: green !important;
  }

  #uploadDome .upload_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  #uploadDome .upload_star .el-upload-list__item label:after {
    content: "";
  }
</style>


// WEBPACK FOOTER //
// src/pages/database/index.vue